import clsx from "clsx";
import { useRef } from "react";
import { useMediaQuery } from "react-responsive";
import ScrollReveal from "scrollreveal";
import makeElementsFall from "../../helpers/physics";
import BlueEye from "../../components/assets/eyes/BlueEye";
import PinkEye from "../../components/assets/eyes/PinkEye";
import YellowEye from "../../components/assets/eyes/YellowEye";
import { useEffect } from "react";

function ServiceName({
    children,
    className,
    style = {}
}) {
    return (
        <div className={clsx(
            "text-heading-2 tablet:text-heading-3 mobile:text-very-large uppercase text-white whitespace-nowrap px-[1rem] py-[0.25rem] font-[600]",
            className
        )}
            style={style}>
            {children}
        </div>
    )
}

export default function ProjectFalling() {
    const container = useRef(null);
    const titleContainer = useRef(null);
    const isTablet = useMediaQuery({
        query: "(max-width: 1000px)"
    })

    useEffect(() => {
        if (container.current) {
            ScrollReveal().reveal(container.current, {
                beforeReveal: () => {
                    if(container.current){
                        makeElementsFall(container.current, Array.from(container.current.querySelectorAll(".falling-item")), isTablet ? "bottom" : "right", isTablet ? [] : [titleContainer.current]);
                    }
                },
                viewFactor: 0.75
            })
        }
    }, []);
    return (
        <div className="min-h-[910px] mobile:min-h-[600px] flex justify-center items-center relative overflow-hidden" ref={container}>
            <div className="absolute left-0 top-[80%] tablet:top-0 tablet:left-[80%] w-[6.25rem] aspect-square falling-item mobile:w-[4rem]" style={{ rotate: isTablet ? "-62deg" : "-31deg" }}>
                <BlueEye />
            </div>
            <div className="absolute left-0 top-[90%] w-[5.375rem] tablet:top-0 tablet:left-[90%] aspect-square falling-item mobile:w-[3rem]" style={{ rotate: isTablet ? "-62deg" : "-31deg" }}>
                <PinkEye version={2}/>
            </div>
            <div className="absolute left-1/3 top-[20%] tablet:top-0 tablet:left-[50%] w-[5.375rem] aspect-square falling-item mobile:w-[3rem]" style={{ rotate: isTablet ? "-62deg" : "-31deg" }}>
                <YellowEye />
            </div>
            <ServiceName className={"bg-zoeil-blue absolute top-[90%] falling-item left-0 tablet:left-[50%] tablet:top-0"} style={{ rotate: isTablet ? "-10deg" : "-20deg" }}>Communication</ServiceName>
            <ServiceName className={"bg-zoeil-pink absolute absolute top-1/2 falling-item left-0 tablet:left-1/2 tablet:top-0"} style={{ rotate: isTablet ? "0deg" : "20deg" }}>Branding</ServiceName>
            <ServiceName className={"bg-zoeil-light-blue absolute top-1/4 falling-item left-0 tablet:top-0 tablet:left-[33%]"} style={{ rotate: isTablet ? "15deg" : "-15deg" }}>Web Design</ServiceName>
            <ServiceName className={"bg-zoeil-yellow absolute top-[80%] falling-item left-0 tablet:top-[0px] tablet:left-0"} style={{ rotate: isTablet && "-90deg" }}>Photo & Video</ServiceName>
            <h2 className="font-[800] text-big-heading whitespace-nowrap tablet:text-[5.5rem] mobile:text-[4rem]" ref={titleContainer}>
                Un Projet ?
            </h2>
        </div>
    )
}